// =====================================================
// 📁 POSCategoryClearButton.tsx
// =====================================================

import { X } from 'lucide-react';

interface Props {
  onClick: () => void;
}

const POSCategoryClearButton = ({
  onClick,
}: Props) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="
        inline-flex
        h-[38px]

        shrink-0
        items-center
        gap-2

        rounded-xl

        bg-[#DC3545]

        px-4

        text-sm
        font-medium
        text-white

        shadow-sm

        transition-all
        duration-200

        hover:bg-opacity-90
        hover:scale-[1.02]

        active:scale-[0.98]
      "
    >
      <X className="h-4 w-4" />

      Limpiar
    </button>
  );
};

export default POSCategoryClearButton;